import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceDataService } from '../services/reference-data.service';

@Pipe({
  name: 'localizeTooltip'
})
export class LocalizeTooltipPipe implements PipeTransform {
  constructor(private referenceDataService: ReferenceDataService) {}

  transform(id: string): string {
    const tooltip = this.referenceDataService.getLocalizeTooltip(id);

    return tooltip ? tooltip : '';
  }
}
